"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var CompetitorReferentialPrice_1 = require("../../../price-calculation/model/CompetitorReferentialPrice");

var ProductPrice_1 = require("../../../product/model/ProductPrice");

var CRPFlag_1 = require("../CRPFlag");
/**
 * Data transfer object that contains CRPs for cleaning review
 *
 * @author RV
 */


var CRPDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CRPDTO, _DomainObject_1$Domai);

  /**
   *
   * @param internalProductId
   * @param competitorId id of competitor's company
   * @param priceZoneId
   * @param actualPrice CRP with state APPROVED (modified by charger and ratio)
   * @param newPrice CRP with state NEW (modified by charger and ratio)
   * @param internalVsCompetitorReferencePriceChangeIndex an index representing the difference
   * between internal regular price and competitor reference price
   * @param flags flags, which marking whether is competitor price high, low or lower than purchase price of internal product
   * @param internalRegularPrice internal(our) regular price for combination product/prizeZone
   */
  function CRPDTO(internalProductId, competitorId, priceZoneId, actualPrice, newPrice, internalVsCompetitorReferencePriceChangeIndex, flags, internalRegularPrice) {
    var _this;

    _classCallCheck(this, CRPDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CRPDTO).call(this));
    _this.internalProductId = internalProductId;
    _this.competitorId = competitorId;
    _this.priceZoneId = priceZoneId;
    _this.actualPrice = actualPrice;
    _this.newPrice = newPrice;
    _this.internalVsCompetitorReferencePriceChangeIndex = internalVsCompetitorReferencePriceChangeIndex;
    _this.flags = flags;
    _this.internalRegularPrice = internalRegularPrice;
    return _this;
  }

  return CRPDTO;
}(DomainObject_1.DomainObject);

exports.CRPDTO = CRPDTO;

CRPDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CRPDTO.name);
  return {
    internalProductId: builder.str('internalProductId'),
    competitorId: builder.str('competitorId'),
    priceZoneId: builder.str('priceZoneId'),
    actualPrice: builder.opt(builder.obj(CompetitorReferentialPrice_1.CompetitorReferentialPrice.name, CompetitorReferentialPrice_1.CompetitorReferentialPrice.schema, function (mat) {
      return CompetitorReferentialPrice_1.CompetitorReferentialPrice.fromDataDict(mat);
    })),
    newPrice: builder.opt(builder.obj(CompetitorReferentialPrice_1.CompetitorReferentialPrice.name, CompetitorReferentialPrice_1.CompetitorReferentialPrice.schema, function (mat) {
      return CompetitorReferentialPrice_1.CompetitorReferentialPrice.fromDataDict(mat);
    })),
    internalVsCompetitorReferencePriceChangeIndex: builder.opt(builder.bigNum('internalVsCompetitorReferencePriceChangeIndex')),
    flags: builder.flags('flags', CRPFlag_1.CRPFlag),
    internalRegularPrice: builder.opt(builder.obj('internalRegularPrice', ProductPrice_1.ProductPrice.productPriceSchema, ProductPrice_1.ProductPrice.fromDataDict))
  };
}();